import { render, staticRenderFns } from "./create-bulk.vue?vue&type=template&id=00b6197d&scoped=true&"
import script from "./create-bulk.vue?vue&type=script&lang=js&"
export * from "./create-bulk.vue?vue&type=script&lang=js&"
import style0 from "./create-bulk.vue?vue&type=style&index=0&id=00b6197d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00b6197d",
  null
  
)

export default component.exports